import React, { useState } from 'react';
import BossDialog from '../../components/BossDialog';
import { EditPageHeader } from '../../components/EditPageHeader';
import { useTranslation } from '../../locale/useTranslation';
import { TimePickerWithFormat } from '../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat';
import { utility } from '../../framework/utility/utilityProvider';
import moment from 'moment';
import * as API from '../../framework/API/api';
import { ENTITYNAME, LOGEVENT, MODULE, SCTE_STATUS, TOAST_TYPES } from '../../framework/constant/constant';
import ToastNotification from '../../components/ToastNotification';

const DetailsScteForm = ({ item = {}, ChannelId, cancelEdit, onSave }) => {

    const lang = useTranslation();
    const blankDataItem = {
        ...item,
        ActionName: item?.ActionName ?? '',
        Duration: item?.Duration ? utility.convertMilisecondsToStringWithFrames(item?.Duration) : "00:00:00:00",
        Time: item?.Time ? moment(new Date(item?.Time)).format("YYYY-MM-DDTHH:mm") : moment(new Date()).format("YYYY-MM-DDTHH:mm"),
        Status: item?.Status ?? SCTE_STATUS.Pending
    }
    const [dataItem, setDataItem] = useState(blankDataItem);

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }

    const isValid = () => {
        if (!dataItem.ActionName || dataItem.ActionName == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_error_message });
            return false;
        }
        if (!dataItem.Time) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_date_time_error_message });
            return false;
        }
        if (!dataItem.Duration || dataItem.Duration == "00:00:00:00") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_duration_error_message });
            return false;
        }
        return true;
    };

    const handleSubmit = async () => {
        if (!isValid()) return;
        let finalData = {
            _id: dataItem?._id,
            SID: dataItem?.SID ?? 0,
            ChannelId: ChannelId,
            ActionName: dataItem?.ActionName,
            Duration: dataItem?.Duration ? utility.convertStringWithFramesToMilliseconds(dataItem?.Duration) : 0,
            Time: dataItem?.Time ? moment(new Date(dataItem?.Time)).valueOf() : 0,
            Status: dataItem?.Status ?? SCTE_STATUS.Pending,
            Archive: dataItem?.Archive ?? false,
            checkDuplicate: true,
            query: [["ActionName", "=", dataItem.ActionName],["ChannelId", "=", ChannelId]],
        }
        console.log(finalData);
        let res = await API.saveData(ENTITYNAME.DAI_SCTES, finalData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.DAI_SCTE, data: res.data, message: res.message };
            API.SaveLogs(logData);
            utility.deleteLocalStorageItem(ENTITYNAME.DAI_SCTES);
            onSave && onSave(res.data);
        } else if(res.code == 413) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${finalData.ActionName} - ${lang.scte_duplicate_error_message}` });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const getEndTime = () => {
        try {
            const startTimeMs = moment(new Date(dataItem.Time)).valueOf();
            const durationMs = utility.convertStringWithFramesToMilliseconds(dataItem.Duration);
            const endTime = moment(startTimeMs + durationMs).format("YYYY-MM-DD HH:mm:ss");
            return endTime;
        } catch (e) {
            return '';
        }
    };


    return (
        <BossDialog title={item.Name ?? lang.dai_sctes_dialog_header} onClose={cancelEdit} width="35vw" >
            <EditPageHeader showTitle={false} onSubmit={handleSubmit} onCancel={cancelEdit} />
            <div className="row mt-2">
                <div className="col-12">
                    <label>{lang.name_label} *</label>
                    <input
                        name="ActionName"
                        type="text"
                        className="form-control form-control-sm"
                        value={dataItem?.ActionName}
                        onChange={onChange}
                    />
                </div>
            </div>
            <div className='row mt-2'>
                <div className="col-6">
                    <label>{lang.start_date_time_label} *</label>
                    <input
                        name="Time"
                        type="datetime-local"
                        className="form-control form-control-sm"
                        value={dataItem?.Time}
                        onChange={onChange}
                    />
                </div>
                <div className="col-6">
                    <label>{lang.duration_label} *</label>
                    <TimePickerWithFormat className="form-control form-control-sm" name="Duration" value={dataItem.Duration} onChange={onChange} />
                </div>
            </div>
            <div className="mt-3 float-right">
                <span className="ml-2 badge badge-pill badge-info px-3 py-2">
                    {lang.end_date_time_label} - {getEndTime()}
                </span>
            </div>

        </BossDialog>
    )
}

export default DetailsScteForm